import axios from "axios";
import groupAvatar from "../assets/logo.png";
const baseUrl = process.env.REACT_APP_API_BASE_URL;
const crowdfundUrl = process.env.REACT_APP_API_CROWDFUND_URL;

export const sendPositiveFeedback = async (articleLink, message) => {
  try {
    return await axios.post(baseUrl, {
      action: "yesThanksApi",
      help_center_article_link: articleLink,
      message: message,
    });
  } catch (error) {
    console.log({ error });
  }
};

export const sendNegativeFeedback = async (articleLink, reason, reasonInfo) => {
  try {
    return await axios.post(baseUrl, {
      action: "notReallyApi",
      help_center_article_link: articleLink,
      reason,
      more_info_about_the_reason: reasonInfo,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getGroupInfo = async (token) => {
  try {
    const response = await fetch(
      `${crowdfundUrl}/groups/contribute-via-web/details?token=${token}`,
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();

    return {
      groupId: data.id,
      groupAvatar: groupAvatar,
      groupName: data.name,
      description: data.description,
      targetAmount: data.targetAmount,
      percentageRaised: data.percentageRaised,
      targeDate: data.targetDate || "Not set",
      raisedAmount: data.totalRaisedAmount,
      timeRemaining: data.timeRemaining || "No Specific",
    };
  } catch (error) {
    console.error("Failed to fetch group info:", error);
    throw error;
  }
};

export const contributeToGroup = async (token, formData) => {
  // 1. Format the phone number to include the 250 prefix if missing
  const formattedPhone = formData.phone.startsWith("250")
    ? formData.phone
    : `250${formData.phone}`;

  // 2. Build the base request body
  const requestBody = {
    token: token,
    amount: Number(formData.amount), // Ensure it's a number
    paymentMethodUsed: formattedPhone,
    paymentMethodUsedType: "mtn_mobile_money", // Hardcoded based on your MOMO check
  };

  // 3. Only add name if anonymous is NOT checked and momoName exists
  if (!formData.anonymous && formData.momoName?.trim()) {
    requestBody.contributorName = formData.momoName;
  }

  try {
    const response = await fetch(
      `${crowdfundUrl}/transactions/contribute-via-web`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      },
    );

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.message || "Something went wrong");
    }

    return result;
  } catch (error) {
    console.error("Contribution Error:", error.message);
    throw error;
  }
};
